export default __webpack_public_path__ + "static/office-yarosl-278b7adbb246dc954ced325910a68e83.png";